import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface UpdateUserBillingDataPayload {
  company?: string;
  vat?: string;
  countryCode?: string;
  city?: string;
  state?: string;
  zip?: string;
  address?: string;
  address2?: string;
}

export interface UserBillingDataResource {
  vat: string;
  isVatVerified: boolean;
  company: string;
  countryCode: string;
  city: string;
  state: string;
  zip: string;
  address: string;
  address2: string;
}

const updateBillingInformation =
  (makeCall: MakeCall) =>
  (userId: number, data: UpdateUserBillingDataPayload) =>
    makeCall<UserBillingDataResource>('PUT', `/user/${userId}/billing-data`, {
      data,
    });

export default updateBillingInformation;

export type UpdateBillingInformation = ReturnType<
  typeof updateBillingInformation
>;
